import { Component, computed, inject, input } from '@angular/core';
import {
	MatterPackageType,
	matterPackageTypeKeys,
	MatterPackageTypeKeys,
	MatterPackageTypeLabels,
} from '@models/matter-package';
import { EnvelopeService } from '@services/envelope/envelope.service';
import { TablerIconComponent } from 'angular-tabler-icons';

@Component({
	selector: 'app-matter-package-type',
	templateUrl: './matter-package-type.component.html',
	imports: [TablerIconComponent],
})
export class MatterPackageTypeComponent {
	private envelopeService = inject(EnvelopeService);
	private envelopes_ = this.envelopeService.envelopeConfigs_;

	public showEnvelopeDeleteLoading_ = computed(
		() =>
			this.envelopeService.deleteEnvelopeLoading_() &&
			this.envelope_()?.status === 'DRAFT' &&
			this.packageTypeLabel() === 'E-Signing',
	);

	public packageTypes_ = input.required<
		Record<MatterPackageTypeKeys, boolean> | undefined
	>();
	public packageId_ = input.required<string>();
	public envelope_ = computed(
		() =>
			this.envelopes_()?.find(
				(envelope) => envelope.id === this.packageId_(),
			) ?? null,
	);

	// Expose constant for template use
	protected readonly isSigningPackageKey =
		matterPackageTypeKeys.IsSigningPackage;

	public packageTypeLabel = computed(() => {
		const isESigning =
			this.packageTypes_()?.[matterPackageTypeKeys.IsSigningPackage] === true;
		const packageType = isESigning
			? MatterPackageType.ESIGNING
			: MatterPackageType.STANDARD;

		return MatterPackageTypeLabels[packageType];
	});

	public haveSignedCount_ = computed<string>(() => {
		const participatingRecipients = this.envelope_()?.recipients.filter(
			(recipient) => recipient.isParticipating,
		);
		if (!participatingRecipients?.length) {
			return '0 of 0 signed';
		}

		return `${participatingRecipients.reduce(
			(count, recipient) => count + (recipient.hasSigned ? 1 : 0),
			0,
		)} of ${participatingRecipients.length} signed`;
	});
}
